import {css} from "@emotion/react";
import React from "react";
import {cssArray, CSSType} from "../../../../utils";
import {card, cardContainer, detailsText} from "./styles";

export interface CardProps {
    details?: string;
    padding?: number | string;
    backgroundColor?: string;
    wrapperCss?: CSSType;
    contentCss?: CSSType;
}



export const Card: React.FC<CardProps> = ({
    wrapperCss: _css,
    children,
    details,
    padding= "24px 40px",
    contentCss,
    backgroundColor,
}) => {
    return <div css={[cardContainer, ...cssArray(_css)]}>
        {details && <div css={detailsText}>{details}</div>}
        <div css={[card, css({ padding, backgroundColor }), cssArray(contentCss)]}>
            {children}
        </div>
    </div>;
};